// src/services/lprService.js
import axios from 'axios';
import apiClient from './apiClient';


const lprService = {
  // Obtener historial de placas registradas
  getLicensePlateHistory: async (params = {}) => {
    try {
      const response = await apiClient.get('/lpr/history', { params });
      return response.data;
    } catch (error) {
      console.error('Error obteniendo historial de placas:', error);
      throw error;
    }
  },

 
};

export default lprService;